import { useMemo, useState } from 'react';

export const useEditStakeholderTabs = () => {
  const [activeTab, setActiveTab] = useState('Personal Details');

  // The Customer Notes tab was removed from the UI (backend data and APIs are untouched).
  const tabs = useMemo(() => ['Personal Details'], []);

  return { activeTab, setActiveTab, tabs };
};
